/* eslint-disable react/display-name */
import * as React from 'react';
var CheckmarkCircleFilled = React.forwardRef(function (_a, ref) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, ref: ref, viewBox: "0 0 24 24" },
        React.createElement("path", { clipRule: "evenodd", d: "M0 12C0 5.373 5.373 0 12 0c6.624.008 11.992 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12zm17.552-5.78a1.25 1.25 0 011.197 1.977l-6.7 9.087a1.263 1.263 0 01-1.787.235l-4.783-3.826a1.251 1.251 0 011.563-1.953l3.767 3.014 5.924-8.04c.196-.267.49-.445.819-.495z", fillRule: "evenodd" })));
});
export default CheckmarkCircleFilled;
//# sourceMappingURL=CheckmarkCircleFilled.js.map